import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SessionService from 'bcl/services/session';
import { on } from '@ember/modifier';
import sort from 'bcl/helpers/sort';
import { fn } from '@ember/helper';
import eq from 'ember-truth-helpers/helpers/eq';
import type LocationModel from 'bcl/models/location';
import type { Store } from '@warp-drive/core';
import type RouterService from '@ember/routing/router-service';
import type CompanyModel from 'bcl/models/company';

interface BasicDataLocationsSignature {
  // The arguments accepted by the component
  Args: {
    model: LocationModel[];
    cancel: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BasicDataLocationsComponent extends Component<BasicDataLocationsSignature> {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare session: SessionService;

  @action
  create() {
    const newModel = this.store.createRecord('location', {
      company: this.session.company,
      active: true,
    });
    this.router.transitionTo('auth.basic-data.location', newModel);
  }
  @action
  edit(location: LocationModel) {
    this.router.transitionTo('auth.basic-data.location', location.id);
  }
  get companyDefaultLocation() {
    const company = this.session.company;
    return company?.default_location;
  }
  @action async setDefaultLocation(location: LocationModel, event: InputEvent) {
    const company = this.session.company;
    if (company) {
      if (event.target.checked) {
        company.default_location = location;
      } else {
        company.default_location = null;
      }

      await company.save();
    }
  }

  <template>
    <h2
      id="locations"
      class="scroll-mt-10 text-xl font-semibold leading-7 text-gray-900"
    >Lager</h2>
    <div class="px-4 px-4 lg:px-8">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">

        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            {{on "click" this.create}}
            class="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >Neues Lager anlegen</button>
        </div>
      </div>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle px-4 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3"
                  >Name</th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >Status</th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >Standard Lager für Lieferungen</th>

                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">

                {{#each (sort @model "name") as |location|}}
                  <tr class="even:bg-gray-50">
                    <td
                      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3"
                    >{{location.name}}</td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >{{if location.active "Aktiv" "Deaktiviert"}}</td>
                    <td
                      class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                    >
                      <label>
                        <input
                          type="checkbox"
                          checked={{eq
                            location.id
                            this.companyDefaultLocation.id
                          }}
                          {{on "change" (fn this.setDefaultLocation location)}}
                          class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </label>
                    </td>

                    <td
                      class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3"
                    >
                      <button
                        type="button"
                        {{on "click" (fn this.edit location)}}
                        class="text-indigo-600 hover:text-indigo-900"
                      >bearbeiten</button>

                    </td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
}
